import type { DashboardContentProps } from 'src/layouts/dashboard';

import { removeLastSlash } from 'minimal-shared/utils';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import { paths } from 'src/routes/paths';
import { usePathname } from 'src/routes/hooks';
import { RouterLink } from 'src/routes/components';

import { DashboardContent } from 'src/layouts/dashboard';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

const NAV_ITEMS = [
  {
    label: 'Subscription',
    icon: <Iconify width={24} icon="solar:document-add-bold" />,
    href: paths.dashboard.billing.root,
  },
  {
    label: 'Abrechnung',
    icon: <Iconify width={24} icon="solar:bill-list-bold" />,
    href: `${paths.dashboard.billing.invoices}`,
  },
  {
    label: 'Verbrauch',
    icon: <Iconify width={24} icon="solar:chart-square-bold" />,
    href: `${paths.dashboard.billing.consumption}`,
  },
];

// ----------------------------------------------------------------------

export function BillingLayout({ children, ...other }: DashboardContentProps) {
  const pathname = usePathname();


  return (
    <DashboardContent {...other}>

      <Tabs value={removeLastSlash(pathname)} sx={{ mb: { xs: 3, md: 5 } }}>
        {NAV_ITEMS.map((tab) => (
          <Tab
            component={RouterLink}
            // @ts-ignore
            key={tab.href}
            label={tab.label}
            icon={tab.icon}
            value={tab.href}
            href={tab.href}
          />
        ))}
      </Tabs>
      {children}
    </DashboardContent>
  );
}
